import styled from 'styled-components';
import { FloatingLabelBaseSkin } from '../../Field/skins/FloatingLabelBase.skin';
export var TextAreaFloatingLabelSkin = styled(FloatingLabelBaseSkin).withConfig({
  displayName: "FloatingLabelskin__TextAreaFloatingLabelSkin",
  componentId: "sc-1vyo8io-0"
})(["left:1px;right:1px;margin-left:8px;margin-right:0;top:16px;bottom:auto;margin-top:2px;padding:12px 8px 8px;padding-bottom:4px;padding-top:12px;line-height:1.15;pointer-events:none;transform:", ";"], function (_ref) {
  var floatAbove = _ref.floatAbove;
  return floatAbove && 'translateY(-50%) scale(0.923)';
});